import Dialog from "@stimulus-components/dialog"

export default class extends Dialog {
  static targets = ["dialog", "content"]

  connect() {
    super.connect()
    if (!this.dialogTarget.open) {
      this.open()
    }
    this.applyBackdrop(true)

    this.boundHandleClose = this.handleClose.bind(this)
    this.dialogTarget.addEventListener("close", this.boundHandleClose)
  }

  disconnect() {
    this.close()
    this.dialogTarget.removeEventListener("close", this.boundHandleClose)
    super.disconnect()
  }

  open() {
    super.open()
    this.applyBackdrop(true)
  }

  backdropClose(event) {
    super.backdropClose(event)
  }

  close() {
    if (this.dialogTarget.open) {
      this.dialogTarget.close()
    }
    this.applyBackdrop(false)

    const modalFrame = document.getElementById('modal')
    if (modalFrame) {
      modalFrame.innerHTML = ''
    }
  }

  closeModal() {
    this.close()
    // Refresh the current page to remove the modal and update the URL
    if (window.Turbo) {
      // Get the base URL without the modal path
      const baseUrl = this.getBaseUrl()
      window.Turbo.visit(baseUrl, { action: "replace" })
    }
  }

  getBaseUrl() {
    const path = window.location.pathname
    
    // Handle tournament management URLs
    if (path.includes('/tournaments/') && path.includes('/manage/')) {
      // Extract the tournament management base URL
      const match = path.match(/^(\/tournaments\/\d+\/manage\/[^\/]+)/)
      if (match) {
        return match[1]
      }
    }
    
    // Try to find the team URL from the current path
    const teamMatch = path.match(/^(\/teams\/\d+)/)
    if (teamMatch) {
      return teamMatch[1]
    }
    
    // For other paths, remove the last segment if it looks like a modal path
    if (path.includes('/new') || path.includes('/edit')) {
      const segments = path.split('/')
      segments.pop() // Remove last segment
      return segments.join('/') || '/'
    }
    
    // Fallback to current path without query params
    return path
  }

  handleBackdropClick(event) {
    // Check if we clicked outside the modal content
    if (this.hasContentTarget && !this.contentTarget.contains(event.target)) {
      event.preventDefault()
      this.closeModal()
    }
  }
  
  handleClose() {
    // Ensure backdrop is removed when dialog closes
    this.applyBackdrop(false)
  }

  applyBackdrop(value) {
    const app = document.getElementById('app')
    if (app) {
      app.inert = value
    } else {
      // Fallback: try to find the main content area
      const main = document.querySelector('main')
      if (main) {
        main.inert = value
      }
    }
  }
}
